import { render, staticRenderFns } from "./Piso.vue?vue&type=template&id=ef3f2476"
import script from "./Piso.vue?vue&type=script&lang=js"
export * from "./Piso.vue?vue&type=script&lang=js"
import style0 from "./Piso.vue?vue&type=style&index=0&id=ef3f2476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports